var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mainConfig.showBreadcrumbs || _vm.mainConfig.jumpToLot || _vm.mainConfig.showPrevNextList)?_c('div',{staticClass:"ta-lot-breadcrumbs-wrapper"},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }